<template>
    <div class="main-modal">
        <el-dialog
            title=""
            :visible.sync="dialogVisible"
            width="11.32rem"
            :show-close="false"
            :before-close="handleClose">
            <div slot="title" class="dialog-header">
                <img src="../../../assets/images/close.png" alt="" @click="handleClose">
            </div>
            <div class="imgs">
                <img v-if="imgId" :src="'resrun-paas/file/downloadFileStream/'+ imgId " alt=""  class="certifacate" >
                <div class="download-img" @click="handleDownload">
                    <img src="../../../assets/images/download-icon.png" alt="" >
                    <p class="download-text">点击下载</p>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
              
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getCopyrightRegisterCers } from '@/api/business';
    export default {
        name:'Download',
        data () {
            return {
                dialogVisible:false,
                rowInfo:{
                    id:'',
                    realName:''
                },
                imgId:''
            }
        },
        mounted() {

        },
        methods: {

            showDialog(row){
                this.dialogVisible = true;
                this.rowInfo = row;
                if(row.id){
                    getCopyrightRegisterCers({id:row.id}).then(res=>{
                        if(res.code==200){
                            this.imgId = res.result[0]
                        }
                    })
                }
            },
            handleClose(){
                this.dialogVisible = false;
            },
            handleDownload() {  
                const xhr = new XMLHttpRequest();
                xhr.open('GET', '/resrun-paas/file/downloadFileStream/'+ this.imgId, true);
                xhr.responseType = 'blob';
                // xhr.setRequestHeader('X-Access-Token',token);
                xhr.onload = () => {
                    const data = xhr.response;
                    const blob = new Blob([data], { type: 'application/octet-stream' });
                    console.log(data,'00000000')
                    let dom = document.createElement('a');
                    let fileName = decodeURI(
                        xhr?.getResponseHeader('content-disposition')?.split(';')[1].split('=')[1] || '',
                    );
                    let url = window.URL.createObjectURL(blob)
                    dom.href = url
                    dom.download = decodeURI(fileName)
                    dom.style.display = 'none'
                    document.body.appendChild(dom)
                    dom.click()
                    dom&&dom?.parentNode?.removeChild(dom)
                    window.URL.revokeObjectURL(url)
                };
                xhr.send();
            } 
        },
        computed: {

        },
        watch: {

        }
    }
</script>

<style lang="less" scoped>
.main-modal{
    .imgs{
        display: flex;
        justify-content: center;
        .certifacate{
            width:100%;
        }
    }
    /deep/.el-dialog{
        border-radius: 5px;
    }
    /deep/.el-dialog__body{
        padding:35px 55px;
        box-sizing: border-box;
        position: relative;
        .download-img{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            text-align: center;
            background: rgb(224 214 214 / 30%);
            padding: 10px 20px;
            border-radius: 10px;
            cursor: pointer;
        }
        .download-text{
            font-size: 0.14rem;
            color: #fff;
            font-family: 'Alibaba-PuHuiTi-M';
        };
        // height: 3.72rem;
    }
    /deep/.el-dialog__header{
        padding:0;
        background: #206BD1;
        color: #fff;
        height:0.76rem;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        .dialog-header{
            height: 100%;
            text-align: center;
            font-size: 0.3rem;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
            img{
                width:36px;
                height:36px;
                cursor:pointer;
                position: absolute;
                right:37px;
                top:19px;
            }
        }
    }
    .main-carousel{
        width:8.86rem;
        margin:0 auto;
        height:100%;
        img{
            width:100%;
            height:100%;
        }
        /deep/.el-carousel__indicators--horizontal{
            bottom: 4%;
            left: initial;
            transform: translateX(0);
            right: 4%;
            .el-carousel__button{
                height: 20px;
                border-radius: 50%;
                width: 20px;
                background-color: #fff;
                opacity: 1;
            }
            .is-active  .el-carousel__button{
                background-color: #366eee;
            }
        
        }
    }
}
 
</style>